import { ShavedText } from "@moim/common";
import * as React from "react";
import {
  BadgeWrapper,
  IconHolder,
  BadgeIcon,
  NameWrapper,
  Name,
} from "./styled";

interface IProps {
  icon: string;
  name: string;
  description: string;
  onClick?: React.MouseEventHandler;
}

const NormalBadge = React.forwardRef<HTMLAnchorElement, IProps>(
  ({ icon, name, description, onClick }, ref) => (
    <BadgeWrapper ref={ref} onClick={onClick}>
      <IconHolder>
        <BadgeIcon src={icon} alt={name} />
      </IconHolder>
      <NameWrapper title={description}>
        <Name>
          <ShavedText value={name} line={2} />
        </Name>
      </NameWrapper>
    </BadgeWrapper>
  ),
);

export default NormalBadge;
